<template>
  <div class="icon">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_8882_4480)">
        <path d="M7.99996 0.666748C6.54957 0.666748 5.13174 1.09684 3.92578 1.90264C2.71982 2.70843 1.77989 3.85374 1.22485 5.19374C0.669803 6.53373 0.524579 8.00822 0.807537 9.43074C1.0905 10.8533 1.78893 12.1599 2.81451 13.1855C3.8401 14.2111 5.14677 14.9095 6.5693 15.1925C7.99183 15.4755 9.46632 15.3302 10.8063 14.7752C12.1463 14.2202 13.2916 13.2802 14.0974 12.0743C14.9032 10.8683 15.3333 9.45048 15.3333 8.00008C15.331 6.05586 14.5576 4.19194 13.1829 2.81717C11.8081 1.4424 9.94418 0.669042 7.99996 0.666748ZM7.99996 14.0001C6.81327 14.0001 5.65324 13.6482 4.66654 12.9889C3.67985 12.3296 2.91081 11.3925 2.45669 10.2962C2.00256 9.19983 1.88374 7.99343 2.11525 6.82954C2.34676 5.66565 2.91821 4.59656 3.75732 3.75744C4.59644 2.91833 5.66553 2.34688 6.82942 2.11537C7.99331 1.88386 9.19971 2.00268 10.2961 2.4568C11.3924 2.91093 12.3295 3.67997 12.9888 4.66666C13.6481 5.65336 14 6.81339 14 8.00008C13.998 9.59079 13.3653 11.1158 12.2405 12.2406C11.1157 13.3654 9.59066 13.9981 7.99996 14.0001Z" :fill="color"/>
        <path d="M8.66671 7.72392V3.99992C8.66671 3.82311 8.59647 3.65354 8.47144 3.52851C8.34642 3.40349 8.17685 3.33325 8.00004 3.33325C7.82323 3.33325 7.65366 3.40349 7.52864 3.52851C7.40361 3.65354 7.33337 3.82311 7.33337 3.99992V7.99992C7.33341 8.17672 7.40367 8.34626 7.52871 8.47125L9.52871 10.4713C9.65444 10.5927 9.82284 10.6599 9.99764 10.6584C10.1724 10.6568 10.3396 10.5867 10.4633 10.4631C10.5869 10.3395 10.657 10.1723 10.6585 9.99752C10.66 9.82272 10.5928 9.65432 10.4714 9.52859L8.66671 7.72392Z" :fill="color"/>
      </g>
      <defs>
        <clipPath id="clip0_8882_4480">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Clock",
  props: {
    color: {
      type: String,
      default: '#0052B4'
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  margin-right: 0.375rem;
  width: 16px;
  height: 16px;
}
</style>